import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    userList: [],
  },
  getters: {
    userList: (state) => state.userList,
  },
  actions: {
    loadUserList(context) {
      return new Promise((resolve, reject) => {
        alice
          .getUserList()
          .then((response) => {
            const { data } = response.data;
            context.commit('setUserListData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addAdmin(context, params) {
      const { userData } = params;
      return new Promise((resolve, reject) => {
        alice
          .addAdmin(userData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addUser(context, params) {
      const { userData } = params;
      return new Promise((resolve, reject) => {
        alice
          .addUser(userData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateUser(context, params) {
      const { userId, userData } = params;
      return new Promise((resolve, reject) => {
        alice
          .updateUser(userId, userData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteUser(context, params) {
      const { userId } = params;
      return new Promise((resolve, reject) => {
        alice
          .deleteUser(userId)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setUserListData(state, data) {
      Vue.set(state, 'userList', data);
    },
  },
};
